/* global mixpanel */

export function libraryCategoryStart ({currentOutlet}) {
  mixpanel.track('Library Category Start', {
    'Current Selected Outlet': currentOutlet
  })
}

export function libraryCategoryChangeOutlet ({currentOutlet}) {
  mixpanel.track('Library Category Change Outlet', {
    'Current Selected Outlet': currentOutlet
  })
}

export function libraryCategoryCreate ({category, allOutlet}) {
  const eventName = (allOutlet) ? 'Library Category Create All Outlet' : 'Library Category Create One Outlet'
  mixpanel.track(eventName, {
    'Name': category.name
  })
}

export function libraryCategoryUpdateOneOutlet ({oldName, newName}) {
  mixpanel.track('Library Category Update One Outlet', {
    'Old Name': oldName,
    'New Name': newName
  })
}

export function libraryCategoryAssignToItems ({name, itemNames}) {
  mixpanel.track('Library Category Assign To Items', {
    'Name': name,
    'Item Names': itemNames
  })
}

export function libraryCategoryDelete ({name}) {
  mixpanel.track('Library Category Delete', {
    'Name': name
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/category.js